import { gql } from "@apollo/client"; import { useMutation } from "@apollo/client/react"; import React, { useState, useContext, useMemo } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import DraftsIcon from '@mui/icons-material/Drafts';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';

import LinkIcon from '@mui/icons-material/Link';
import toast, { Toaster } from 'react-hot-toast';
import { getDateToString } from '../../../utils/convert';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { NOTIFICACION_ESTADO as estado } from '../../../consts/notificacionEstado';
import { NotificacionContext } from '../../../context/NotificacionContext';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';

const locale = "es-ES";

export default function NotificacionesDataGrid({ rows }) {

  const { countNotificacionesNoLeidas, setCountNotificacionesNoLeidas, setMensajes, marcarNotificacionesLeidas } = useContext(NotificacionContext);

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const navigate = useNavigate();

  // useEffect(() => {
  // }, []);      

  const [open, setOpen] = useState(false);

  const [messageDialog, setMessageDialog] = useState({
    idNotificacion: 0,
    titulo: '',
    descripcion: '',
    estado: 0
  });

  const [listaNotificaciones, setListaNotificiones] = useState(rows);

  const [filtro, setFiltro] = useState({
    fechaDesde: null,
    fechaHasta: null
  });

  const handleChangeFechaDesde = (value) => {
    setFiltro((prevState) => {
      return { ...prevState, fechaDesde: value };
    });
  };

  const handleChangeFechaHasta = (value) => {
    setFiltro((prevState) => {
      return { ...prevState, fechaHasta: value };
    });
  };

  const MSaveNotificacionEstado = gql`
        mutation MSaveNotificacionEstado($idNotificacion: Long!, $estado: Int!) {
            saveNotificacionEstado   
            (    
                idNotificacion: $idNotificacion,
                estado: $estado
            )    
            {
                success,
                error,
                valorEsperado
            }
    }`;

  const MSaveNotificacionAllEstado = gql`
        mutation MSaveNotificacionAllEstado($idUsuario: Long!, $estado: Int!) {
            saveNotificacionAllEstado   
            (    
                idUsuario: $idUsuario,
                estado: $estado
            )    
            {
                success,
                error,
                valorEsperado
            }
    }`;


  const [changeNotificacionAllEstado] = useMutation(MSaveNotificacionAllEstado, {
    onCompleted: (resp) => {
      if (resp.saveNotificacionAllEstado.success) {
        const lista = listaNotificaciones.map((item) => {
          return {
            ...item,
            estado: estado.LEIDO
          };
        });

        setListaNotificiones(lista);
        setCountNotificacionesNoLeidas(0);
        marcarNotificacionesLeidas();
        setMensajes(lista);
        if (countNotificacionesNoLeidas > 0) toast.success("Todas las notificaciones fueron marcadas como leídas");
      }
    },
    onError: (resp) => {
      //setMensajeError("ERRORDB");
      return false;
    }
  });

  const [changeNotificacionEstado, { data }] = useMutation(MSaveNotificacionEstado, {
    onCompleted: (data) => {
      if (data.saveNotificacionEstado.success) {
        setOpen(false);

        const lista = listaNotificaciones.map((item) => {
          if (messageDialog.idNotificacion === item.idNotificacion) {
            return {
              ...item,
              estado: estado.LEIDO
            };
          } else {
            return {
              ...item
            };
          }
        });

        setListaNotificiones(lista);
        setMensajes(lista);

        if (countNotificacionesNoLeidas > 0) toast.success("Notificacion leída");
        setCountNotificacionesNoLeidas(countNotificacionesNoLeidas > 0 ? countNotificacionesNoLeidas - 1 : 0);
      }
    },
    onError: (data) => {
      //setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleLink = (link) => {
    navigate(link);
  };

  const handleView = (notificacion) => {
    setMessageDialog((prevState) => {
      return {
        ...prevState,
        idNotificacion: notificacion.idNotificacion,
        titulo: notificacion.titulo,
        descripcion: notificacion.comentario,
        estado: notificacion.estado
      };
    });
    setOpen(true);
  };

  const handleClickLeidas = () => {
    let result = changeNotificacionAllEstado({ variables: { idUsuario: idUsuario, estado: estado.LEIDO } });
  };

  const handleAceptarDialog = () => {
    console.log('IdNotificacion: ', messageDialog.idNotificacion);
    console.log('estado: ', messageDialog.estado);

    if (messageDialog.estado === estado.NO_LEIDO) {
      let result = changeNotificacionEstado({ variables: { idNotificacion: messageDialog.idNotificacion, estado: estado.LEIDO } });
    }

    console.log(rows);
    setOpen(false);


    console.log(rows);
  };

  const initialColumns = [
    { field: 'titulo', headerName: 'Titulo', flex: 0.4 },
    { field: 'comentario', headerName: 'Notificacion', flex: 0.4 },
    {
      field: 'fechaAlta',
      headerName: 'Fecha',
      flex: 0.2,
      renderCell: (params) => params.value ? getDateToString(params.value, true) : ''
    },
    {
      field: 'estado', headerName: 'Estado', flex: 0.1, sortable: false,
      renderCell: (params) =>
        <>
          {params.row.estado === estado.LEIDO && <DraftsIcon />}
          {params.row.estado === estado.NO_LEIDO && <MarkunreadIcon />}
        </>

    },
    {
      field: 'accion', headerName: 'Acciones', flex: 0.1, sortable: false,
      renderCell: (params) =>
        <div className='actions-cell'>
          <VisibilityIcon
            sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
            onClick={() => handleView(params.row)}
            titleAccess='Visualizar'
            style={{ marginRight: '10px' }} />

          {
            params.row.link && <LinkIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              onClick={() => handleLink(params.row.link)}
              titleAccess='Ir al enlace'
              style={{ marginRight: '-20px' }} />

          }
        </div>

    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  return (
    <>
      <DataGridGenerico
        columns={columns}
        fileNameExport='Notificaciones'
        rows={listaNotificaciones}
        toolbar={false} />


      <CustomButton
        disabled={!listaNotificaciones.find((x) => x.estado === estado.NO_LEIDO)}
        size="small"
        onClick={handleClickLeidas}
        style={{ marginTop: '10px' }}>

        Marcar todas leídas
      </CustomButton>



      <CustomDialog
        maxWidth="md"
        open={open}
        title={messageDialog.titulo}
        onAccept={handleAceptarDialog}>

        {messageDialog.descripcion}
      </CustomDialog>
    </>);

}